<template>
    <div
        class="group relative h-full overflow-hidden rounded-12 bg-[#FFFFFF0D] p-3 transition-colors duration-300 md:hover:bg-white/15">
        <div class="absolute inset-0 size-full">
            <div class="bg-noise"></div>
        </div>
        <div class="relative flex h-full flex-col">
            <div
                class="max-h-full w-full shrink-0 overflow-hidden rounded-12 bg-accent/10 transition-colors duration-150">
                <picture
                    class="aspect-video size-full object-cover transition-all duration-500 md:group-hover:scale-110">
                    <source
                        v-if="item.image[0].webp_url"
                        type="image/webp"
                        :srcset="
                            getMediaLink(item.image[0].webp_url, 600) || ''
                        " />
                    <source
                        v-else-if="
                            !item.image[0].webp_url && !item.image[0].url
                        "
                        type="image/webp"
                        srcset="
                            /assets/images/ui/placeholder/webp/cromi.webp
                        " />
                    <img
                        loading="lazy"
                        :alt="
                            item.image[0].url || item.image[0].webp_url
                                ? item.image[0].alt || ''
                                : 'нет изображения'
                        "
                        :src="
                            getMediaLink(item.image[0].url, 600) ||
                            '/assets/images/ui/placeholder/jpg-png/cromi.png'
                        "
                        class="aspect-video size-full object-cover transition-all duration-500 md:group-hover:scale-110" />
                </picture>
            </div>
            <time
                v-if="item.published_at"
                v-html="date"
                :datetime="item.published_at"
                class="mt-5 block text-16/148 font-medium text-accent-100" />
            <div class="mt-2 flex h-full flex-col justify-between md:mt-3">
                <h3
                    v-html="item.name"
                    class="text-20/120 font-semibold text-ash-200 lg:text-24/133" />
                <a
                    v-if="item.link"
                    rel="nofollow"
                    target="_blank"
                    :href="item.link"
                    class="mt-2 line-clamp-2 text-16/150 font-medium text-accent-100 transition-colors duration-300 hover:text-accent-600 md:mt-5">
                    {{ item.link }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IMediaPublicationsItem } from '~/components/pages/about/media-publications-section/media-publications.types'

import { formatPublicationDate } from '~/utils/publication-date'

const props = defineProps({
    item: {
        type: Object as PropType<IMediaPublicationsItem>,
        required: true,
    },
})

const date: ComputedRef<string> = computed(() => {
    if (!props.item.published_at) return ''

    return formatPublicationDate(props.item.published_at)
})
</script>
